import { Animated } from 'react-native';
import styled from 'styled-components/native';

export const Container = styled(Animated.View)``;
